import { useTranslation } from '@nextgen-web-framework/all';
import useTimer from '../../utils/customHooks/useTimer';
import styles from './CountdownClock.module.scss';

const CountdownClock = () => {
  const t = useTranslation();
  const [secondsLeft] = useTimer();
  const remainingSecondsToResend = secondsLeft && secondsLeft > 9 ? `${secondsLeft}` : `0${secondsLeft}`;
  return (
    <div data-testid="left-timer-test-id" className={styles['identity-countdown-clock']}>{`${t(
      'identity.VerifyOtp.resend',
    )} ${remainingSecondsToResend}`}</div>
  );
};

export default CountdownClock;
